<div class="kryptomons-section">
  <div class="loader-while" *ngIf="!parsedSuccess && !noKryptomons">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
  <div class="kryptomons-side" [ngClass]="{'full-width': noKryptomons}" *ngIf="parsedSuccess || noKryptomons">
    <div class="no-kryptomon-container" *ngIf="(isOnboarding || startertoHatch) && parsedSuccess">
      <div class="chat-container">
        <div class="chat-box">
          <img src="./assets/img/Prof-light.png" *ngIf="!timesUp"/>
          <div class="chat-box-text" *ngIf="!timesUp">
            <countdown units="Minutes | Seconds" [divider]="divider" [text]="text" end="{{ timer }}"></countdown>
            <p>It's almost time to meet your Kryptomons, they are now in their egg form, it will take 3 minutes to hatch.<p>
                <p>In the meantime you can watch the video introduction I've prepared for you!</p>
                <div class="button-gradient" (click)="showVideoOverlay = !showVideoOverlay">Play Video</div>
          </div>
          <div class="chat-box-text" *ngIf="(timesUp && startertoHatch) && !itHatchemall">
            <h1 class="title-gradient gradient-pp">It's time to hatch!</h1>
            <p>Your Kryptomons are ready to born, your journey begins today.<p>
                <p>Click on the Kryptomon you want to hatch and be ready to conquer Kogaea!</p>
                <div class="button-gradient" (click)="hatchEmAll()" *ngIf="!isLoading">
                  Hatch'em all!
                </div>
                <div class="button-gradient" *ngIf="isLoading">
                  <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
                </div>
          </div>
          <div class="chat-box-text" *ngIf="itHatchemall">
            <h1 class="title-gradient gradient-pp">It's time to play!</h1>
            <p>Congratulations, you are now finally all set!<p>
            <p>Open the game, take care of your Kryptomons and good luck in becoming the strongest Kryptomon's trainer!</p>
            <div class="button-gradient" (click)="openGame()">
              Play
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-kryptomon-container" *ngIf="canRedeemFree && !isOnboarding && parsedSuccess">
      <div class="chat-container">
        <div class="chat-box">
          <img src="./assets/img/Prof-light.png" />
          <div class="chat-box-text">
            <h1>Do you wanna play with free Kryptomons?</h1>
            <p>We have created the amazing Synthetic Kryptomons that are totally free to redeem and will be super helpful along your way.<br/>Don't waste any time and get your hands on these awesome new tech companions and let's rock this journey together!</p>
            <div class="button-gradient" (click)="showStartersOverlay = !showStartersOverlay">Get yours</div>
          </div>
        </div>
      </div>
    </div>
    <div class="kryptomons-container" *ngIf="parsedSuccess">
      <div class="kryptomons-container-tier" *ngFor="let ranking of rankingArray">
        <div class="container-tier-title">
          <div class="Stars" style="--rating: {{ranking.value}}"></div>
          <h3>{{ranking.name}}</h3>
        </div>
        <div class="kryptomons-cards">
          <div class="other-card" *ngFor="let kr of parsedKryptomon | kryptomonRanking: ranking.name" id="otherKryptomon" (click)="openDetails(kr.data.tokenId)" [ngClass]="{'overflow': kr.data.isRentedOut}">
            <div class="cr cr-top cr-right cr-purple" *ngIf="kr.data.isRentedOut">Rented</div>
            <div class="any-activity-todo" *ngIf="!kr.data.isRentedOut">
              <img src="./assets/img/Icon/hatch.svg" *ngIf="kr.data.isReadyToHatch" />
              <img src="./assets/img/Icon/evolve.svg" *ngIf="kr.data.isReadyToEvolve" />
              <img src="./assets/img/Icon/frozen-icon.svg" *ngIf="kr.data.gameMetadata.isFreezed==1 && kr.data.status>0 && !kr.data.isReadyToEvolve" />
            </div>
            <div class="other-card-img" [ngClass]="{'full-width': kr.data.status==0}">
              <img src="{{kr.data.image}}" [ngClass]="{'grayed-out': kr.data.isRentedOut}" />
            </div>
            <div class="other-card-content">
              <div class="name-row">
                <span>{{kr.data.name}}</span>
                <span *ngIf="kr.data.order" class="price-span">${{kr.data.order.priceUSD.toLocaleString()}}</span>
                <img class="rented" src="./assets/img/Icon/playdex.png" *ngIf="kr.data.rental || kr.data.isRentedOut" />
              </div>
              <div class="other-card-rating">
                <div class="Stars" style="--rating: {{kr.data.tierNumber}}"></div>
                {{kr.data.tierName}}
              </div>
              <span>Speciality: {{kr.data.speciality}}</span>
              <div class="other-card-icons">
                <div class="other-card-starter" *ngIf="kr.data.isStarter">
                  <img src="./assets/img/Icon/Starter.png" />
                </div>
                <div class="other-card-element">
                  <img src="{{kr.data.mainFamilyImage}}" />
                </div>
                <div class="other-card-element">
                  <img src="{{kr.data.secondaryFamilyImage}}" />
                </div>
                <div class="other-card-breed" *ngIf="kr.data.breedingTotal">
                  <img src="./assets/img/Icon/Heart.png" />
                  {{kr.data.breedingDone}}/{{kr.data.breedingTotal}}
                </div>
                <div class="other-card-sex">
                  <img src="{{kr.data.genderIcon}}" />
                </div>
                <div class="other-card-gen">
                  GEN: {{kr.data.genes.generation}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kryptomons-container-tier legacy" *ngIf="kryptomonsV1.length>0">
        <div class="container-tier-title">
          <div class="Stars" style="--rating: 0"></div>
          <h3>Legacy</h3>
          <div class="kryptomons-cards">
            <div class="other-card" *ngFor="let k of kryptomonsV1; let i = index">
              <div class="other-card-img">
                <img src="./assets/img/grayed.png" />
              </div>
              <div class="other-card-content">
                <img class="egg-img-lock" src="./assets/img/Icon/Lock.png" />
                <p>This Kryptomon has an old DNA string. Upgrade to 2.0 and unlock its full potential.</p>
                <div class="button-outline" (click)="migrateKryptomon(k, i)" *ngIf="!k.isMigrating">
                  Migrate
                </div>
                <div class="button-gradient" *ngIf="k.isMigrating">
                  <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-kryptomon-container" *ngIf="noKryptomons">
      <div class="chat-container">
        <div class="chat-box">
          <img src="./assets/img/portal-op.png" />
          <div class="chat-box-text">
            <h1 class="title-gradient gradient-pp">Welcome!</h1>
            <p>Welcome to da crib, you're a newcomer here ain't ya? You'll be wanting yer own nifty little Kryptomon I suppose?<p>
                <p>Don't sweat it, I've got just the thing to get you groovin'</p>
                <div class="button-gradient" (click)="goToOnboarding()">Let's start</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="video-intro-overlay" *ngIf="showVideoOverlay">
  <fa-icon [icon]="['fas', 'times']" (click)="showVideoOverlay = !showVideoOverlay"></fa-icon>
  <video class="video-embed" controls autoplay>
    <source src="./assets/video/intro.mp4" type="video/mp4">
  </video>
</div>
<div class="pick-starter-overlay" *ngIf="showStartersOverlay">
  <fa-icon [icon]="['fas', 'times']" (click)="closeStarterOverlay()" class="close-icon-overlay"></fa-icon>
  <div class="pick-starter-section">
    <div class="pick-starter-container" *ngIf="starterKryptomons==undefined">
      <div class="pick-starter-message">
        <img src="./assets/img/Prof-light.png" class="prof" />
        <div class="starter-message-text">
          <h1 class="title-gradient gradient-pp ">Time to choose your Synthetic!</h1>
          <p>Kryptomons are complicated creatures, I've tried to make it easier for you to chose your companion, you'll have time to learn more about them, but first you need to find your first companion otherwise you won't be able to enter in Koagea.</p>
        </div>
      </div>
      <div class="pick-starter-egg-selector">
        <div class="egg-selector-item" *ngFor="let i of [0,1,2]">
          <div class="egg-selector-select">
            <select [(ngModel)]="starterPick[i]" (ngModelChange)="selectElementStarter(i)">
              <option value="default" disabled>Select Element</option>
              <option [value]="op" *ngFor="let op of startersLegend">{{op}}</option>
            </select>
          </div>
          <div class="egg-selector-image">
            <img src="{{pickedStarter[i].img}}" *ngIf="pickedStarter[i]!==undefined" />
          </div>
          <div class="egg-selector-description">
            <span *ngIf="pickedStarter[i]!==undefined">{{pickedStarter[i].description}}</span>
          </div>
        </div>
      </div>
      <div class="egg-selector-actions">
        <div class="button-gradient" *ngIf="allPicked && !isLoading" (click)="signMessage()">
          Confirm Selection
        </div>
        <div class="button-gradient" *ngIf="isLoading">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
        <div class="button-grey" *ngIf="!allPicked">
          Confirm Selection
        </div>
      </div>
    </div>
    <div class="starter-picked-container" *ngIf="starterKryptomons!==undefined">
      <div class="pick-starter-message">
        <img src="./assets/img/Prof-light.png" class="prof" />
        <div class="starter-message-text">
          <h1 class="title-gradient gradient-pp ">Congratulations!</h1>
          <p>You got your first 3 Synthetic Kryptomons, these creatures will help you to start your Journey, but remember they are limited compared to their real counterpart, but they are great for you to learn more about Kryptomon and Koagea.</p>
        </div>
      </div>
      <div class="picked-started-section">
        <div class="other-card" *ngFor="let kr of starterKryptomons">
          <div class="other-card-img full-width">
            <img src="{{kr.image}}" />
          </div>
          <div class="other-card-content">
            <div class="name-row">
              <span>{{kr.name}}</span>
            </div>
            <div class="other-card-rating">
              <div class="Stars" style="--rating: {{kr.tierNumber}}"></div>
              {{kr.tierName}}
            </div>
            <span>Speciality: {{kr.speciality}}</span>
            <div class="other-card-icons">
              <div class="other-card-starter">
                <img src="./assets/img/Icon/Starter.png" />
              </div>
              <div class="other-card-element">
                <img src="{{kr.mainFamilyImage}}" />
              </div>
              <div class="other-card-element">
                <img src="{{kr.secondaryFamilyImage}}" />
              </div>
              <div class="other-card-sex">
                <img src="{{kr.genderIcon}}" />
              </div>
              <div class="other-card-gen">
                GEN: {{kr.generation}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="egg-selector-actions">
        <div class="button-gradient" (click)="refreshPageAfterStarter()">
          Close
        </div>
      </div>
    </div>
  </div>
</div>
